import { z } from "zod";

import { fetchWithThrow } from "@rosette/web_utils/src/fetchWithThrow.js";
import type { Badge } from "@rosette/ts/src/business/badge/Badge.js";


export const GrantBadgeRequest = z.object({
    userPublicID: z.string(),
    badgePublicID: z.string(),
});
export type GrantBadgeRequest = z.infer<typeof GrantBadgeRequest>;


export const GrantBadgeResponse = z.object({
    success: z.boolean(),
});
export type GrantBadgeResponse = z.infer<typeof GrantBadgeResponse>;


export async function grantBadge(userPublicID: string, badge: Badge): Promise<void> {
    const request: GrantBadgeRequest = {
        userPublicID,
        badgePublicID: badge.getID(),
    };
    const response = await fetchWithThrow("/api/admin/grantBadge", {
        method: "POST",
        credentials: "include",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
    });
    GrantBadgeResponse.parse(await response.json());
}
